// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"2e5ee5d2","238":"3df78368","727":"9d9feace","767":"5ee0a81b"}[chunkId] + ".chunk.css";
};